import { render, staticRenderFns } from "./Dialog_SellGrantShop.vue?vue&type=template&id=0197165b&scoped=true&"
import script from "./Dialog_SellGrantShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_SellGrantShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0197165b",
  null
  
)

export default component.exports